"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemBadge = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = _interopRequireDefault(require("../../../../../utils/theming"));

var _reactIntl = require("react-intl");

var _Badge = _interopRequireDefault(require("@match/react-component-library/components/Badge"));

var _Box = _interopRequireDefault(require("@match/react-component-library/components/Box"));

var _VisuallyHidden = _interopRequireDefault(require("@match/react-component-library/components/VisuallyHidden"));

var _constants = require("@match/react-component-library/components/theme/constants");

var _messages = require("../../../../../constants/messages");

var MenuItemBadge = function MenuItemBadge(_ref) {
  var count = _ref.count,
      showMenuIndicatorDot = _ref.showMenuIndicatorDot;

  if (showMenuIndicatorDot) {
    return _react.default.createElement(DotBadge, null, _react.default.createElement(_VisuallyHidden.default, null, _react.default.createElement(_reactIntl.FormattedMessage, {
      id: _messages.MESSAGE_ID.NEW_RECOMMENDATIONS
    })));
  }

  return _react.default.createElement(_Box.default, {
    left: _constants.SPACE.MEDIUM,
    position: "absolute",
    top: _constants.SPACE.NONE,
    display: "flex"
  }, _react.default.createElement(_Badge.default, {
    count: count
  }), _react.default.createElement(_VisuallyHidden.default, null, _react.default.createElement(_reactIntl.FormattedMessage, {
    id: _messages.MESSAGE_ID.NEW_RECOMMENDATIONS,
    values: {
      count: count
    }
  })));
};

exports.MenuItemBadge = MenuItemBadge;
var DotBadge = (0, _theming.default)('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    left: theme.space.xlarge,
    position: 'absolute',
    top: theme.space.none,
    height: '8px',
    width: '8px',
    backgroundColor: theme.palette.core2_100,
    borderRadius: '100%'
  };
});